module.exports = __webpack_public_path__ + "assets/img/83@3x.7046a8fa.png";